<template>

    <div class="fs-4 text-center">عزيزي المتبرع</div>
    <div class="fs-4 d-flex justify-content-center mb-4"> للتبرع بمبلغ {{donation_amount}} 
      <div class="sar-icon mt-1" />
       ادخل معلومات البطاقة  
    </div>
</template>
<script> 
export default {
  name: "DonationAmount",  
  props: {
    donation_amount: {
      type: Number,
      required: true
    }
  }
};
</script>
<style scoped lang="scss">
@import "@/styles/components/riyal-logo";

</style>